document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = document.querySelector('[data-mobile-drawer]');
      if (!drawer) return;
      const open = drawer.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-slide]')];
    const dots = [...slider.querySelectorAll('[data-dot]')];
    if (slides.length <= 1) return;
    let current = 0;
    let timer;
    const delay = Number(slider.dataset.autoplay || 5000);
    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
    };
    const start = () => {
      clearInterval(timer);
      if (slider.dataset.autoplayEnabled === 'true') timer = setInterval(() => show(current + 1), delay);
    };
    slider.querySelector('[data-prev]')?.addEventListener('click', () => { show(current - 1); start(); });
    slider.querySelector('[data-next]')?.addEventListener('click', () => { show(current + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    slider.addEventListener('mouseenter', () => clearInterval(timer));
    slider.addEventListener('mouseleave', start);
    show(0); start();
  });
});
